import { followAuthorSelectors } from '@lialo/core/lib/pages/followAuthor';

import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { HowToRegOutlined, PersonAddAltOutlined } from '@mui/icons-material';
import { useShouldShowFollowButton } from './useShouldShowFollowButton';
import { useFollowState } from './useFollowState';

const classes = {
  startIcon: 'followButton-startIcon',
};

const StyledButton = styled(Button)(() => ({
  textTransform: 'none',
  fontSize: 12,
  whiteSpace: 'nowrap',

  [`& .${classes.startIcon}`]: {
    marginRight: 4,
  },
})) as typeof Button;

interface Props {
  authorId: string;
  authorName: string;
  className?: string;
}

export const FollowButton = ({ authorId, authorName, className }: Props) => {
  const { t } = useTranslation();

  const isLoading = useSelector(followAuthorSelectors.selectIsLoading);
  const isFetchingFolloweeIds = useSelector(followAuthorSelectors.selectIsFetchingFolloweeIds);

  const showButton = useShouldShowFollowButton(authorId);
  const { isFollowing, onClick } = useFollowState(authorId, authorName);

  return showButton ? (
    <>
      <StyledButton
        disabled={isLoading || isFetchingFolloweeIds}
        classes={{
          startIcon: classes.startIcon,
        }}
        className={className}
        onClick={onClick}
        size="small"
        variant={'text'}
        startIcon={
          isFollowing ? <HowToRegOutlined fontSize={'inherit'} /> : <PersonAddAltOutlined fontSize={'inherit'} />
        }
      >
        {isFollowing ? t('actions.unfollow') : t('actions.follow')}
      </StyledButton>
    </>
  ) : null;
};
